(function () {
  const Wishlist = {
    key: 'branzos_wishlist',
    drawer: document.querySelector('[data-wishlist-drawer]'),
    itemsEl: document.querySelector('[data-wishlist-items]'),

    get() {
      try {
        return JSON.parse(localStorage.getItem(this.key) || '[]');
      } catch {
        return [];
      }
    },

    async render() {
      if (!this.itemsEl) return;
      const handles = this.get();
      if (!handles.length) {
        this.itemsEl.innerHTML = `
          <div class="cart-drawer__empty">
            <span class="cart-drawer__empty-emoji">💔</span>
            <p>Your wishlist is empty. Tap the heart on any product to save it here.</p>
          </div>`;
        return;
      }

      this.itemsEl.classList.add('is-loading');
      this.itemsEl.innerHTML = '<span class="loading-spinner"></span>';

      const products = await Promise.all(
        handles.map((handle) =>
          fetch(`/products/${handle}.js`)
            .then((res) => res.json())
            .catch(() => null)
        )
      );

      const html = products
        .filter(Boolean)
        .map((p) => {
          const variant = p.variants[0];
          const img = p.images && p.images[0]
            ? `<img class="cart-item__image" src="${p.images[0].split('?')[0]}?width=160&height=160&crop=center" alt="${p.title}" loading="lazy">`
            : `<span class="cart-item__emoji">🍬</span>`;
          return `
            <div class="cart-item">
              <a href="/products/${p.handle}">${img}</a>
              <div class="cart-item__details">
                <p class="cart-item__name"><a href="/products/${p.handle}">${p.title}</a></p>
                <span class="cart-item__price">${window.ShopifyTheme.money(variant.price)}</span>
              </div>
              <div class="cart-item__controls">
                <button class="btn btn--small btn--gradient" data-wishlist-add data-id="${variant.id}">${window.ShopifyTheme.i18n.addToCart}</button>
                <button class="cart-item__remove" data-wishlist-remove data-handle="${p.handle}">Remove</button>
              </div>
            </div>`;
        })
        .join('');

      this.itemsEl.classList.remove('is-loading');
      this.itemsEl.innerHTML = html;
    },
  };

  document.addEventListener('click', (e) => {
    const add = e.target.closest('[data-wishlist-add]');
    if (add && window.ShopifyCart) {
      e.preventDefault();
      window.ShopifyCart.add(add.dataset.id, 1, add);
    }
    const remove = e.target.closest('[data-wishlist-remove]');
    if (remove) {
      e.preventDefault();
      let items = Wishlist.get();
      items = items.filter((h) => h !== remove.dataset.handle);
      localStorage.setItem(Wishlist.key, JSON.stringify(items));
      Wishlist.render();
      document.querySelectorAll('[data-wishlist-btn]').forEach((btn) => {
        btn.classList.toggle('is-active', items.includes(btn.dataset.wishlistHandle));
      });
      document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
        el.textContent = items.length;
      });
    }
  });

  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-drawer-toggle="[data-wishlist-drawer]"]');
    if (toggle) {
      Wishlist.render();
    }
  });

  window.ShopifyWishlist = Wishlist;
})();
